export const PERMISSIONS = {
  ARANCELES_HISTORIAL_READ: 'portal-prestadores.aranceles.historial.read',
  ARANCELES_REAJUSTES_READ: 'portal-prestadores.aranceles.reajustes.read',
  ARANCELES_REAJUSTES_UPDATE: 'portal-prestadores.aranceles.reajustes.update',
  ARANCELES_VIGENTE_DOWNLOAD: 'portal-prestadores.aranceles.vigente.download',
  ARANCELES_VIGENTE_READ: 'portal-prestadores.aranceles.vigente.read',
  BENEFICIARIOS_CONSULTA_READ: 'portal-prestadores.beneficiarios.consulta.read',
  BENEFICIARIOS_HISTORIAL_READ: 'portal-prestadores.beneficiarios.historial.read',
  BENEFICIARIOS_PADRON_DOWNLOAD: 'portal-prestadores.beneficiarios.padron.download',
  BENEFICIARIOS_PADRON_READ: 'portal-prestadores.beneficiarios.padron.read',
  BENEFICIARIOS_REPORTERIA_DOWNLOAD: 'portal-prestadores.beneficiarios.reporteria.download',
  BENEFICIARIOS_REPORTERIA_READ: 'portal-prestadores.beneficiarios.reporteria.read',
  BENEFICIARIOS_TITULAR_DOWNLOAD: 'portal-prestadores.beneficiarios.titular.download',
  BENEFICIARIOS_TITULAR_READ: 'portal-prestadores.beneficiarios.titular.read',
  PRESTADOR_ANTECEDENTES_READ: 'portal-prestadores.prestador.antecedentes.read',
  PRESTADOR_BONOS_CREATE: 'portal-prestadores.prestador.bonos.create',
  PRESTADOR_BONOS_READ: 'portal-prestadores.prestador.bonos.read',
  PRESTADOR_CARGAS_CREATE: 'portal-prestadores.prestador.cargas.create',
  PRESTADOR_CARGAS_DOWNLOAD: 'portal-prestadores.prestador.cargas.download',
  PRESTADOR_CUENTAS_DOWNLOAD: 'portal-prestadores.prestador.cuentas.download',
  PRESTADOR_CUENTAS_READ: 'portal-prestadores.prestador.cuentas.read',
  PRESTADOR_LIQUIDACIONES_APPROVE: 'portal-prestadores.prestador.liquidaciones.approve',
  PRESTADOR_LIQUIDACIONES_DELETE: 'portal-prestadores.prestador.liquidaciones.delete',
  PRESTADOR_LIQUIDACIONES_READ: 'portal-prestadores.prestador.liquidaciones.read',
  PRESTADOR_LIQUIDACIONES_UPDATE: 'portal-prestadores.prestador.liquidaciones.update',
  PRESTADOR_NOMINAS_DOWNLOAD: 'portal-prestadores.prestador.nominas.download',
  PRESTADOR_NOMINAS_READ: 'portal-prestadores.prestador.nominas.read',
  PRESTADOR_PAGOS_READ: 'portal-prestadores.prestador.pagos.read',
  STAFF_ALTA_CREATE: 'portal-prestadores.staff.alta.create',
  STAFF_ALTA_DOWNLOAD: 'portal-prestadores.staff.alta.download',
  STAFF_BAJA_DELETE: 'portal-prestadores.staff.baja.delete',
  STAFF_BAJA_DOWNLOAD: 'portal-prestadores.staff.baja.download',
  STAFF_HISTORIAL_READ: 'portal-prestadores.staff.historial.read',
  STAFF_VIGENTE_DOWNLOAD: 'portal-prestadores.staff.vigente.download',
  STAFF_VIGENTE_READ: 'portal-prestadores.staff.vigente.read',
} as const;

export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];
